import Navigation from "./navigation";
import Aboutsliderimages from "./sliderimages";
import Footer from "./footer";
import LatestEventsSection from "./LatestEventsSection";
import ren1 from "./images/mmmmm036.jpg";
import ren15 from "./images/ren1 (28).jpg";
import redirectToDonation from "./donationRedirect";

const About = () => {
  return (
    <>
        <div className="fixed top-0 left-0 right-0 z-50">
        <Navigation />
      </div>
      <div className="hero-section2 px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="text-white text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold py-8">
          About Me
        </div>
      </div>

      <div className="section-margin-half"></div>

      <div className="max-width px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="hero-section-text">
          <p className="text-center sm:text-left text-sm sm:text-base md:text-lg font-semibold mb-4" style={{ color: "var(--primary)" }}>
            WE ARE WAITING FOR YOU
          </p>
          <h1 className="big-text-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-left mb-6 sm:mb-8 md:mb-10">
            Meet Ren Nushaj
          </h1>
          
          {/* First content section - image right */}
          <div className="flex flex-col lg:flex-row items-start gap-6 sm:gap-8 md:gap-10 lg:gap-12 mb-8 sm:mb-12 md:mb-16">
            <div className="w-full lg:w-1/2">
              <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4 sm:mb-6">
                Ren Nushaj is an attorney, public servant, and proud Michigander
                running to bring integrity, justice, and real results to the
                Michigan Senate. With over 15 years of legal experience, Ren has
                spent his career fighting for working families, transparent
                government, and strong, safe communities.
              </p>
              <p className="text-base sm:text-lg md:text-xl text-gray-700">
                As a small town prosecutor and attorney Ren has worked every day
                on the front lines of local government—advising city leaders,
                holding bad actors accountable, and standing up for the public
                interest. He's also a founding partner at the Troy Law Center,
                where he manages a full-service legal practice focused on
                litigation, municipal law, and community advocacy.
              </p>
            </div>
            <div className="w-full lg:w-1/2">
              <img
                src={ren1}
                className="w-full h-auto rounded-lg shadow-lg"
                alt="Ren Nushaj portrait"
              />
            </div>
          </div>

          {/* Slider section */}
          <div className="w-full mb-8 sm:mb-12 md:mb-16">
            <Aboutsliderimages />
          </div>

          {/* Second content section - image left */}
          <div className="flex flex-col lg:flex-row items-start gap-6 sm:gap-8 md:gap-10 lg:gap-12 mb-8 sm:mb-12 md:mb-16">
            <div className="w-full lg:w-1/2 order-2 lg:order-1">
              <img
                src={ren15}
                className="w-full h-auto rounded-lg shadow-lg"
                alt="Ren Nushaj at work"
              />
            </div>
            <div className="w-full lg:w-1/2 order-1 lg:order-2">
              <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4 sm:mb-6">
                Ren began his career in public service as an intern for U.S.
                Senator Carl Levin, where he learned the value of principled
                leadership rooted in facts, fairness, and compassion. A graduate
                of Wayne State University Law School and lifelong advocate for
                civil rights, he's a regular speaker on legal and civic issues,
                presenting at local schools, universities, and community centers
                across Southeast Michigan.
              </p>
              <p className="text-base sm:text-lg md:text-xl text-gray-700">
                A certified mediator and real estate broker, Ren brings a
                well-rounded perspective to public service—one that prioritizes
                the community. He's running for State Senate to restore faith in
                our democratic institutions, to fix our broken infrastructure,
                and to ensure that every Michigander—no matter their zip
                code—has the opportunity to thrive.
              </p>
            </div>
          </div>

          {/* Final paragraph */}
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4 sm:mb-6 text-center lg:text-left">
            This campaign isn't about politics as usual. It's about standing up
            for the people of Troy, Sterling Heights, Rochester Hills, City of
            Rochester, Utica, Shelby Township and Oakland Township —and
            delivering the honest, hardworking leadership they deserve.
          </p>
        </div>
      </div>
      
      <div className="section-margin"></div>
      <div className="events-container"></div>
      <LatestEventsSection count={3} />
      <div className="section-margin-half"></div>
      <div className="section-margin"></div>

      {/* Donate section */}
      <div className="max-width px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="donate-ornage-section flex flex-col sm:flex-row items-center justify-between gap-6 sm:gap-8 md:gap-10 lg:gap-12 py-6 sm:py-8 md:py-10 px-6 sm:px-8 md:px-10 bg-orange-500 rounded-lg">
          <div className="text-center sm:text-left text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white">
            Donate to Our Campaign.
          </div>
          <div className="flex flex-wrap gap-4 sm:gap-6 md:gap-8 lg:gap-10 justify-center sm:justify-end">
            <button
              className="jose donate-btn-white text-sm sm:text-base md:text-lg font-medium py-3 sm:py-4 px-6 sm:px-8 md:px-10 min-w-[140px] sm:min-w-[160px] md:min-w-[180px] rounded-lg hover:bg-gray-100 transition-colors duration-300"
              onClick={redirectToDonation}
            >
              Donate Now
            </button>
          </div>
        </div>
      </div>

      <div className="section-margin"></div>
      <Footer />
    </>
  );
};

export default About;